import type { QueryClient } from '@tanstack/react-query'

/** A receipt can cover several orders. Prefix invalidation also refreshes those details. */
export function invalidatePaymentQueries(client: QueryClient) {
  return Promise.all([
    'monthly-order', 'monthly-orders', 'monthly-company-orders', 'customer-tasks', 'customer', 'customer-orders', 'payments', 'payment', 'collection-overview', 'finance-orders', 'uninvoiced-orders', 'invoices', 'invoice',
    'receivable-invoices', 'invoice-payments', 'order', 'orders', 'task-badges',
    'workflow-voucher-assistance', 'workflow-pending-applications', 'approval-tasks', 'workflow-records', 'workflow-direct-receivables', 'workflow-unmatched-receipts',
  ].map(key => client.invalidateQueries({ queryKey: [key] })))
}
